import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Register from './Register/Register';
import Login from './Login/Login';
import Services from './Page/Service/Service';
import Home from './Page/Home/Home';
import BecomeASeller from './Page/SubHeaderPage/BecomeASeller/BecomeASeller';
import SellerLogin from './Page/SubHeaderPage/BecomeASeller/SellerLogin/SellerLogin';
import CreateAccount from './Page/SubHeaderPage/BecomeASeller/CreateAccount/CreateAccount';
import CreateUserAccount from './Login/CreateUserAccount';
import VerifyMobile from './Login/VerifyEmail';
import CartPage from './CartIcon/CartPage';
import ProductsByCategory from './Page/ProductsByCategory/ProductsByCategory';
import WishlistPage from './Page/Wishlist/WishlistPage'; 
import ProductDetailsPage from './Page/ProductDetails/ProductDetails';
import { ToastContainer } from 'react-toastify';
import PageLayout from './Components/PageLayout';
import Profile from './Page/Profile/Profile';
import SellerRegistrationForm from './SellerRegistrationForm/SellerRegistrationForm';
import CategoryPage from './Page/CategoryPage/CategoryPage';
import ProductsBySubCategory from './Page/ProductsBySubCategory/ProductsBySubCategory';
import OrderDetails from './Page/OrderDetails/OrderDetails';
import Orders from './Page/Profile/Orders';
import AddressManagement from './Page/Profile/AddressManagement';
import ProfileLayout from './Page/Profile/ProfileLayout';
import ProfileInfo from './Page/Profile/ProfileInfo';
import AddressManagementPage from './Page/Profile/AddressManagementPage';
import UserWallet from './Page/Profile/Wallet';
import NotificationsPage from './Page/NotificationsPage';
import MyBankAccount from './Page/MyBankAccount/MyBankAccount';
import PrivacyPolicy from './Page/PrivacyPolicy/PrivacyPolicy';
function App() {
 
  return (
    <div>
      <BrowserRouter>
      <Routes>
      <Route path='/' Component={Home} />
      <Route path='/home' Component={Home} />
      <Route path='/login' Component={Login} />
      <Route path='/register' Component={Register} />
      <Route path='/seller-sign-up' Component={SellerRegistrationForm} />

      <Route path='/product-by-category/:categoryId' element={<ProductsByCategory/>} />
      <Route path="/product/:productId" element={ <ProductDetailsPage />} />

      <Route path='/become-seller' Component={BecomeASeller} />
      <Route path='/seller-login' Component={SellerLogin} />
      <Route path='/create-account' Component={CreateAccount} />
      <Route path='/create-user-account' Component={CreateUserAccount} />
      <Route path="/verify-number" element={<VerifyMobile />} />
      <Route path='/cart' element={<CartPage/>} />
      <Route path='/wishlist' element={<WishlistPage/>} />
      <Route path='/profile' element={<Profile/>} />
       <Route path="/orders/:orderItemId" element={<OrderDetails />} />
       <Route path="/category/:categoryId" element={<CategoryPage />} />
       <Route path="/subcategory/:categoryId" element={<ProductsBySubCategory />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />


       <Route path="/profile" element={<ProfileLayout />}>
        <Route index element={<ProfileInfo />} />
        <Route path="addresses" element={<AddressManagementPage />} />
        <Route path="orders" element={<Orders />} />
        <Route path="wallet" element={<UserWallet />} />
        <Route path="bank-account" element={<MyBankAccount />} />
      </Route>
      </Routes>
      </BrowserRouter>
     <ToastContainer
        position="top-right"
        autoClose={1000}
      />
   
    </div>
  );
}
 
export default App;
 
